import React from 'react';
import AISection from '../components/AISection';

export default function AICareersPage() {
  return (
    <section className="page-section">
      <div className="page-hero">
        <span className="page-hero-label">AI & Careers</span>
        <h1>Stay Ready for an <span>AI-Shaped</span> Job Market</h1>
        <p>
          Understand how AI is changing work, which skills still matter most, and how to prepare
          for stronger opportunities with confidence.
        </p>
      </div>
      <AISection />
    </section>
  );
}
